module.exports = __webpack_public_path__ + "static/img/scan-code.f2dd84f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/web/footer/scan-code.jpg
// module id = rr9x
// module chunks = 1